import * as Sentry from "@sentry/react";
import { isTelemetryEnabled } from "./env";

type CaptureExceptionOptions = {
  extra?: Record<string, unknown>;
  tags?: Record<string, unknown>;
};

export function captureException(error: unknown, options?: CaptureExceptionOptions) {
  if (!isTelemetryEnabled()) return;

  const err = error instanceof Error ? error : new Error(String(error));

  Sentry.withScope((scope) => {
    if (options?.tags) {
      for (const [key, value] of Object.entries(options.tags)) {
        if (value === undefined || value === null) continue;
        scope.setTag(key, String(value));
      }
    }
    if (options?.extra) {
      scope.setExtras(options.extra);
    }
    Sentry.captureException(err);
  });
}
